module.exports = __webpack_public_path__ + "static/media/Conditions-p2-Transport - Agreement V3.0_ECPY_EN_form with WatrMk&CopyRg.docx - copie.d830519a.jpg";